module.exports = __webpack_public_path__ + "static/sui-table-striped-c876a2c668272e8cec8c8defdd14e665.png";